import { createRequest } from '../../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import store from '../../store'

const getAutocompleteResults = (label, text) => {
  const state = store.getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest(
    '/api/articles/autocomplete?value=' + text + '&field=' + label + '&config=' + state.present.article.serverConfig,
    'GET',
    undefined,
    token,
  ).then(response => response.json())
}

const getFieldAutocompleteResults = (label, text) => {
  const state = store.getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest(
    '/api/articles/fieldAutocomplete?value=' +
      text +
      '&field=' +
      label +
      '&config=' +
      state.present.article.serverConfig,
    'GET',
    undefined,
    token,
  ).then(response => response.json())
}

export { getAutocompleteResults, getFieldAutocompleteResults }
